export enum FirebaseEvent {
  WebAppSignUp = 'web_app_sign_up',
}
